import React from 'react';

const HwcTouChengCreatePanel = () => {
  return <div>HwcTouChengCreatePanel</div>;
};

export default HwcTouChengCreatePanel;
